import { useState } from "react";
import { Link } from "react-router-dom";
import { Wrench, Loader2, ArrowLeft, MailCheck } from "lucide-react";
import { api } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [resetUrl, setResetUrl] = useState(null);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await api("/auth/password-reset/request", { method: "POST", body: JSON.stringify({ email: email.trim() }) });
      setDone(true);
      if (res.reset_url) setResetUrl(res.reset_url);
    } catch (e2) {
      setError(e2.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-midnight to-midnight-2 px-6 py-12">
      <div className="w-full max-w-md rounded-2xl bg-card p-8 shadow-xl">
        <div className="mb-6 flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-midnight"><Wrench className="h-4 w-4 text-brand" /></div>
          <span className="font-display text-lg font-bold tracking-widest text-midnight">PRO GARAGES</span>
        </div>
        {done ? (
          <div className="text-center">
            <MailCheck className="mx-auto mb-3 h-12 w-12 text-success" />
            <h1 className="font-display text-2xl font-bold uppercase text-midnight">Check your email</h1>
            <p className="mt-2 text-sm text-muted-foreground">If an account exists for <b>{email}</b>, we've sent a reset link. It's valid for 30 minutes.</p>
            {resetUrl && (
              <div className="mt-4 rounded-lg border border-border bg-secondary p-3 text-left">
                <p className="text-[11px] font-bold tracking-wide text-muted-foreground">PREVIEW MODE — RESET LINK</p>
                <a href={resetUrl} data-testid="preview-reset-link" className="break-all text-xs text-brand underline">{resetUrl}</a>
              </div>
            )}
            <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-brand-2"><ArrowLeft className="h-4 w-4" />Back to sign in</Link>
          </div>
        ) : (
          <>
            <h1 className="font-display text-2xl font-bold uppercase text-midnight">Forgot password</h1>
            <p className="mt-1 text-sm text-muted-foreground">Enter your email and we'll send a reset link.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <label className="block">
                <span className="mb-1.5 block text-[11px] font-bold tracking-widest text-muted-foreground">EMAIL</span>
                <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="owner@garage.co.uk"
                  className="w-full rounded-lg border border-input bg-card px-3.5 py-3 text-base outline-none focus:border-brand focus:ring-2 focus:ring-brand/20" />
              </label>
              {error && <p className="rounded-md bg-danger-bg px-3 py-2 text-sm text-danger">{error}</p>}
              <button type="submit" disabled={loading} data-testid="forgot-submit-btn" className="flex w-full items-center justify-center gap-2 rounded-lg bg-brand py-3.5 text-sm font-extrabold tracking-widest text-white disabled:opacity-60">
                {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "SEND RESET LINK"}
              </button>
            </form>
            <Link to="/login" className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-brand-2"><ArrowLeft className="h-4 w-4" />Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
